import React from "react";

const Espera: React.FC = () => {

  return (
    <div className="overflow-hidden">
      <picture className="absolute inset-0 w-full h-full object-cover z-0">

        <img
        src="https://res.cloudinary.com/dhoyyqszi/image/upload/f_auto,q_auto/v1723078887/bg2_gmfow3.jpg"
        alt="Background"
        className="absolute inset-0 w-full h-screen object-cover"
        loading="lazy"
        id="gallery-background-image"
        style={{ height: "100%", transform: "rotate(180deg)" }}
        />
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-black"></div>
      </picture>
      <div className="bg-black " >
        
      <section className="relative w-full bg-gradient-radial-mixed-transparent2 text-white min-h-screen">
        <div className="absolute inset-0 bg-gradient-to-t from-transparent via-transparent to-black opacity-20 z-20"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black opacity-100 z-20"></div>
        <div style={{ maxWidth: "800px", display:"flex", alignItems:"center", height:"100vh" }} className="relative z-30 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8   ">
          
        {/* <div
          className="max-w-[200px] lg:max-w-[250px] absolute top-1/2 left-1/2 -translate-x-[200%] sm:-translate-x-[20rem] md:-translate-x-[240%] lg:-translate-x-[250%] xl:-translate-x-[300%] 2xl:-translate-x-[350%] translate-y-[100%] md:translate-y-[100%] lg:translate-y-[100%] z-20 "
          style={{
            width: "100%",
            height: "auto",
            display: "inline-block",
          }}
        >
          <img
            src="/static/sphere.png"
            alt="Decorative sphere"
            style={{
              display: "block",
              width: "100%",
              height: "auto",
            }}
            loading="lazy"
          />
        </div>
        <div
          className="w-[40%] lg:w-[50%] absolute top-1/2 left-1/2 translate-x-[80%] md:translate-x-[90%] lg:translate-x-[70%] xl:translate-x-[90%] 2xl:translate-x-[110%] translate-y-[0rem] md:translate-y-[0%] lg:translate-y-[0%] xl:translate-y-[0%] z-30 block"
          style={{
            
            height: 'auto',
            
          }}
        >
          <img
          src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1738954324/torus2_byghbt.png"
          alt="Decorative sphere"
          style={{
            display: 'block',
            width: '100%',
            height: 'auto',
          }}
          loading="lazy"
        />
        </div> */}
        <div className=" glass-effect-noborder px-12 pb-16 pt-10 rounded-lg shadow-lg z-40 w-full   flex flex-col items-center">
        <img
              src="/static/logo-mr.png"
              alt="Nombre de tu empresa"
              className="w-[200px] sm:w-[300px] h-auto pt-1"
              loading="lazy"
            />
            <div
          className="text-center font-bold pb-0 pt-5 text-[1.5em] sm:text-[1.5em] 2xl:text-[1.8em]">
          <h2 style={{ lineHeight: 0.9, }}>
            Próximamente
          </h2>
          
          </div>
            </div>
          



          
        </div>
        
      </section >
      
    </div >
    
    </div>
  );
};

export default Espera;
